import React from 'react'
import { useTranslation } from 'react-i18next'
import { Separator, LayoutBand, Image, H3, H5, Paragraph } from '@fs/zion-ui'
import { cdnRoot } from '../../services/services'

export default function PrepareForSpirituallyTemple() {
  const [t] = useTranslation()

  return (
    <main>
      <LayoutBand maxWidth="xs">
        <Separator />
        <Image
          alt={t('temple.picture.alt.practical.templeprep', 'Practical youth temple preparation')}
          src={`${cdnRoot}/connect/informational/youth_temple_prep_practical.png`}
        />
        <Separator />
        <H3>{t('informational.temple.prepare.practical.heading', 'Practical Preparation')}</H3>
        <Separator />
        <Paragraph>
          {t(
            'informational.temple.prepare.practical.intro',
            "Your child's first time in the temple baptistry can be very special, even life-changing. But anything that's new and unknown can bring questions about what to expect. Practical preparation, on top of personal study and spiritual preparation, can help. Below is a list of reminders your child can review to help his or her first visit be more meaningful and comfortable:"
          )}
        </Paragraph>
        <Separator />
        <H5>{t('informational.temple.prepare.practical.step1', '1. Receiving a Temple Recommend')}</H5>
        <Separator />
        <Paragraph>
          {t(
            'informational.temple.prepare.practical.step1-details',
            "One step in preparing for temple baptisms includes having an interview with your bishop or branch president and receiving a limited-use recommend. Even if you don't have easy access to a temple or your first temple visit isn't happening soon, prophets have encouraged you to still receive and maintain an active recommend. The interview is similar to the one before your baptism. You will discuss your testimony of Jesus Christ and His gospel as well as how you're doing in trying to keep the commandments. You are welcome to invite a parent or another adult to join you during your interview. (See Part 1 in this series for additional information about temple recommend questions)"
          )}
        </Paragraph>
        <Separator />
        <H5>{t('informational.temple.prepare.practical.step2', '2. Clothing')}</H5>
        <Separator />
        <Paragraph>
          {t(
            'informational.temple.prepare.practical.step2-details',
            'On the day you go to the temple, try to wear your Sunday best, but don’t worry about bringing any additional clothing. All temples provide each baptistry patron with a white jumpsuit, underclothing and a towel. If you have long hair, the temple can also provide you with an elastic hair tie for use in the font. You may want to bring your own hairbrush or comb to use when you’re done.'
          )}
        </Paragraph>
        <Separator />
        <H5>{t('informational.temple.prepare.practical.step3', '3. Entering the Temmple')}</H5>
        <Separator />
        <Paragraph>
          {t(
            'informational.temple.prepare.practical.step3-details',
            'When you enter the temple, a temple worker will check your recommend and direct you where to go. Males and females go to separate dressing rooms to change. Private locker spaces are provided to change into the jumpsuit. If the temple baptistry is busy, you may need to wait. But the baptistry is a great place to think, ponder, and pray and there are usually scriptures available for you to read.'
          )}
        </Paragraph>
        <Separator />
        <H5>{t('informational.temple.prepare.practical.step4', '4. Preforming Baptisms')}</H5>
        <Separator />
        <Paragraph>
          {t(
            'informational.temple.prepare.practical.step4-details',
            "When it is your time to be baptized, a worker will direct you to the font. There is a handrail to help you step down into the water. You'll likely be baptized for a few people, one after another. The baptisms will be similar to your own baptism but each time you will be acting on behalf of a deceased person. After you're baptized, a worker will give you a towel and direct you to the locker room where there is a private shower to rinse off. Then you'll go back to your individual locker, where you'll change into the clothes you wore to the temple."
          )}
        </Paragraph>
        <Separator />
        <H5>{t('informational.temple.prepare.practical.step5', '5. Preforming Confirmations')}</H5>
        <Separator />
        <Paragraph>
          {t(
            'informational.temple.prepare.practical.step5-details',
            "In each baptistry, there is at least one room used for performing confirmations. You will wear your own clothing for confirmations. Priesthood holders will place their hands on your head, just like when you were confirmed after your own baptism. If you don't bring names of your own ancestors, you might do confirmations first before performing any baptisms. These confirmations would be for deceased people who already had baptisms performed for them."
          )}
        </Paragraph>
        <Separator />
        <H5>{t('informational.temple.prepare.practical.step6', '6. Enjoying the Experience')}</H5>
        <Separator />
        <Paragraph>
          {t(
            'informational.temple.prepare.practical.step6-details',
            "The temple is the house of the Lord. It's a wonderful place to focus on feeling peace and happiness. So relax and enjoy this wonderful experience as you serve God and others. Plus, kind temple workers are available everywhere you go in the temple and are happy to help in any way they can."
          )}
        </Paragraph>
        <Separator />
      </LayoutBand>
    </main>
  )
}
